<template>
  <div class="user">
    <el-form :inline="true" :model="formInline" class="form">
      <el-form-item label="订单号查询">
        <el-input v-model="formInline.order_on" placeholder="订单号"></el-input>
      </el-form-item>
      <el-form-item label="门店列表">
        <el-select v-model="formInline.store_id" filterable placeholder="请选择门店" clearable>
          <el-option
            v-for="item in roomList"
            :key="item.id"
            :label="item.room_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户昵称">
        <el-input v-model="formInline.nickname" placeholder="用户昵称"></el-input>
      </el-form-item>
      <el-form-item label="操作类型">
        <el-select v-model="formInline.operation" filterable placeholder="请选择操作类型" clearable>
          <el-option
            v-for="item in operationList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户手机号">
        <el-select v-model="formInline.mobile" filterable placeholder="手机号" clearable>
          <el-option
            v-for="item in optionsMobile"
            :key="item.mobile"
            :label="item.mobile"
            :value="item.mobile"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList" class="form_btn">
          <img src="../assets/static/query.png" class="btn_img" />查询
        </el-button>
      </el-form-item>
    </el-form>
    <div class="sorting">
      <div class="export_btn" style="margin-right: 20px;">导出</div>
    </div>
    <div class="table_list" style="flex-grow: 1;overflow-y: scroll;" ref="tableRef">
      <el-table
        :data="tableData"
        border
        style="width: 100%;"
        :row-class-name="tableRowClassName"
        :row-style="tableRowStyle"
        :height="tableHeight"
      >
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="center" prop="id" label="id" width="150"></el-table-column>
        <el-table-column align="center" prop="room_name" label="门店名称"></el-table-column>
        <el-table-column align="center" prop="nickname" label="用户昵称"></el-table-column>
        <el-table-column align="center" prop="mobile" label="用户手机号"></el-table-column>
        <!-- <el-table-column align="center" prop="nickname" label="骑手姓名"></el-table-column>
        <el-table-column align="center" prop="mobile" label="骑手手机号"></el-table-column> -->
        <el-table-column align="center" prop="type_name" label="操作类型"></el-table-column>
        <el-table-column align="center" prop="create_time" label="操作时间" width="180"></el-table-column>
        <el-table-column align="center" prop="door_id" label="设备编号"></el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <!-- <div style="display: flex;"> -->
            <el-button @click="handleClickVideo(scope.row)" type="text" class="right_btn">视频回放</el-button>
            <el-button
              @click="handleClickDetail(scope.row)"
              type="text"
              class="right_btn right_btn_color"
            >删除</el-button>
            <!-- </div> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      class="pagination"
    ></el-pagination>
  </div>
</template>
  <script>
import {
  UserMobile,
  LogRecording,
  roomList,
  deleteLog,
  OperationType
} from "@/utils/api/index";

export default {
  name: "logRecording",
  props: ["storeId"],
  data() {
    return {
      formInline: {
        order_on: "",
        store_id: "",
        mobile: "",
        nickname: "",
        operation: ""
      },
      currentPage: 1,
      tableData: [],
      pageSize: 10,
      total: 0,
      optionsMobile: [],
      tableHeight: 200,
      operationList: [],
      roomList: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      const div = this.$refs.tableRef;
      this.tableHeight = div.offsetHeight;
    });
    this.formInline.store_id = this.storeId;
    this.getData()
  },
  methods: {
    getData(type) {
      this.getList(type);
      this.getUserMobile();
      this.getRoomList();
      this.getOperation();
    },
    getOperation() {
      OperationType({}).then(res => {
        this.operationList = res.data;
      });
    },
    getList(type) {
      console.log(type==1,'typetypetype')
      if(type==1) {
        this.total = 0;
        this.tableData = [];
      }
      LogRecording({
        order_on: this.formInline.order_on,
        store_id: this.formInline.store_id,
        nickname: this.formInline.nickname,
        mobile: this.formInline.mobile,
        page: this.currentPage,
        limit: this.pageSize,
        id: this.formInline.operation
      }).then(res => {
        this.total = res.data.count;
        this.tableData = res.data.data;
      });
    },
    getRoomList() {
      roomList({
        name: this.nameTop
      }).then(res => {
        this.roomList = res.data;
      });
    },
    getUserMobile() {
      UserMobile({
        is_block: 0
      }).then(res => {
        this.optionsMobile = res.data;
      });
    },
    handleClickVideo(row) {
      this.$emit("clickVideoReplay", {
        type: 2,
        row
      });
    },
    handleClickDetail(row) {
      this.$confirm("此操作将永久删除该跳日志, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteLog({ id: row.order_id }).then(res => {
            this.$message({
              type: "success",
              message: res.message
            });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
    handleCurrentChange(e) {
      console.log(e, "current");
      this.currentPage = e;
      this.getList();
    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
      //   return "";
    },
    tableRowStyle({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return {
          background: "#16264a"
        };
      } else {
        return {
          background: "#0d193c"
        };
      }
    }
  }
};
</script>
  <style scoped lang="scss">
.user {
  // padding: 20px;
  height: calc(100% - 74px);
  padding: 10px;
  margin: 10px;
  box-sizing: border-box;
  background: #213456;
  display: flex;
  flex-direction: column;
}
.form {
  margin-left: 30px;
  color: #d4e6ff !important;
  :deep(.el-form-item__label) {
    font-size: 14px;
    color: #d4e6ff;
  }
  :deep(.el-input__inner) {
    height: 36px;
    background: #051238;
    border-radius: 2px;
    color: #ffffff;
  }
  .form_btn {
    width: 90px;
    height: 36px;
    background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
    border-radius: 4px;
    border: 1px solid #5fbcf5;
    .btn_img {
      width: 16px;
      vertical-align: middle;
      margin-right: 6px;
    }
  }
}
.table_list {
  margin: 30px;
  box-sizing: border-box;
  margin-top: 0;
  flex-grow: 1;
  overflow-y: scroll;
  :deep(.el-table__body tr.hover-row > td) {
    background-color: transparent !important;
  }
  .el-table {
    background-color: #0d193c;
    border: 1px solid #2f416b;
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: transparent;
  }

  .el-table__fixed-right::before,
  .el-table__fixed::before {
    background: transparent !important;
  }
}
.sorting {
  display: flex;
  align-items: center;
  height: 64px;
  background: #29456e;
  margin: 30px;
  margin-top: 35px;
  margin-bottom: 0;
  padding-left: 30px;
  box-sizing: border-box;
  .export_btn {
    height: 32px;
    background: #29456e;
    border-radius: 4px;
    border: 1px solid #3dc1ff;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    line-height: 32px;
    padding: 0 20px;
  }
}
.right_btn {
  width: 90px;
  height: 36px;
  background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
  border-radius: 4px;
  border: 1px solid #5fbcf5;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  padding-bottom: 28px;
  margin-right: 12px;
}
.right_btn_color {
  background: linear-gradient(180deg, #a9801d 0%, #b56625 100%);
  border-radius: 4px;
  border: 1px solid #fcd486;
}
.right_btn_color_big {
  background: linear-gradient(180deg, #0e6871 0%, #25b587 100%);
  border-radius: 4px;
  border: 1px solid #5fbcf5;
}
.el-pagination {
  text-align: center;
  margin-top: 24px;
  margin-bottom: 14px;
}
.pagination {
  :deep(.el-pagination__total) {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.88);
    margin-top: 4px;
  }
  :deep(.el-input__inner) {
    background: #051238;
    border-radius: 6px;
    font-size: 16px;
    color: #cccccc;
    border: 0;
    margin-top: 4px;
  }
  :deep(.btn-prev) {
    width: 36px;
    height: 36px;
    background: #29456e;
    border-radius: 7px;
  }
  :deep(.el-pager li) {
    // width: 36px;
    height: 36px;
    border-radius: 7px;
    background: #29456e;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: #ffffff;
    line-height: 36px;
    font-size: 18px;
    border-radius: 7px;
    margin: 0 5px;
  }
  :deep(.btn-next) {
    width: 36px;
    height: 36px;
    background: #29456e;
    border-radius: 7px;
  }
  :deep(.el-pagination__jump) {
    font-size: 18px;
    margin-top: 4px;
  }
  :deep(.el-pager li.active) {
    background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%) !important;
    border: 1px solid #5fbcf5;
  }
}
.table_list::-webkit-scrollbar {
  width: 3px !important; /* 滚动条宽度 */
}
:deep(thead .el-table__cell) {
  background-color: #16264a !important;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
}
:deep(.el-checkbox__inner) {
  background: transparent;
  width: 24px;
  height: 24px;
}
:deep(.el-checkbox__inner::after) {
  top: 38%;
  left: 42%;
}
:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner::before) {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

:deep(.warning-row) {
  background: #0d193c;
  font-size: 16px;
  color: #d4e6ff;
}

:deep(.success-row) {
  background: #16264a;
  font-size: 16px;
  color: #d4e6ff;
}
</style>
